import { useContext, useState } from "react";

import { useTranslation } from "react-i18next";

import { BannerType, BannerView } from "@dotnet/telematics-design-system";

import DialogConfirmation from "components/DesignComponents/DialogConfirmation";
import AlertContext, { ALERT_STATUS } from "context/alert/alertContext";
import ParamsContext from "context/params/paramsContext";
import { useApi } from "shared/hooks/useApi";
import { ENDPOINTS } from "shared/types/enums";

import { RevertProps } from "./types";

export const Revert = ({
    title,
    description,
    buttonText,
    confirmationTitle,
    confirmationDescription,
    deleteDataQuery,
    successMessage,
    successCallback
}: RevertProps) => {
    const { setAlert } = useContext(AlertContext);
    const { rootCompany } = useContext(ParamsContext);

    const { t } = useTranslation();
    const { deleteData, handleResponse } = useApi();

    const [isOpenConfirmationDialog, setIsOpenConfirmationDialog] =
        useState(false);

    const [isLoading, setIsLoading] = useState(false);

    const openConfirmationDialog = () => setIsOpenConfirmationDialog(true);
    const closeConfirmationDialog = () => setIsOpenConfirmationDialog(false);

    const handleSubmit = async () => {
        try {
            setIsLoading(true);

            await deleteData(
                ENDPOINTS.Companies,
                rootCompany?.id as number,
                deleteDataQuery
            );

            successCallback();
            closeConfirmationDialog();

            setAlert({ status: ALERT_STATUS.Success, title: successMessage });
        } catch (error) {
            handleResponse(error);
        }

        setIsLoading(false);
    };

    return (
        <>
            <BannerView
                bannerType={BannerType.Info}
                title={title}
                description={description}
                link={{
                    children: buttonText,
                    onClick: openConfirmationDialog
                }}
            />

            <DialogConfirmation
                isOpen={isOpenConfirmationDialog}
                title={confirmationTitle}
                description={confirmationDescription}
                isLoading={isLoading}
                onClose={closeConfirmationDialog}
                onSubmit={handleSubmit}
                confirmBtnTitle={t("Button##yes")}
            />
        </>
    );
};
